import React from 'react';

interface FilterPillProps {
  label: string;
  count?: number;
  active?: boolean;
  onClick: () => void;
  testid?: string;
}

/**
 * Rounded outlined pill for tab/filter bars.
 *
 * Inactive: subtle border + muted text
 * Active:   red border + red text + faint red background
 *
 * Usage:
 * ```tsx
 * <FilterPill label="All" count={4} active={activeTab === 'all'} onClick={() => setActiveTab('all')} />
 * ```
 */
export const FilterPill: React.FC<FilterPillProps> = ({ label, count, active = false, onClick, testid }) => {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={[
        'flex-shrink-0 flex items-center gap-1.5 px-4 py-1.5 rounded-full border text-xs font-medium transition-colors',
        active
          ? 'border-sossiety-red bg-sossiety-red/10 text-sossiety-red'
          : 'border-white/20 bg-transparent text-white/50 hover:text-white/70 hover:border-white/40',
      ].join(' ')}
    >
      {label}
      {count !== undefined && count > 0 && (
        <span className={active ? 'text-sossiety-red/70' : 'text-white/30'}>
          ({count})
        </span>
      )}
    </button>
  );
};
